import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import NavbarForOnboardingForm from "../onboarding/NavbarForOnbardingForm";
import { useLoading } from "../LoadingContext";

function EditUser() {
  const navigate = useNavigate();
  const { id } = useParams(); // Get the user id from the URL parameters

  // Initializing state with empty strings to avoid null/undefined issues
  const [userData, setUserData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    organization: "",
    designation: "",
    role: "",
    user_type: "",
  });

  const { loading, setLoading } = useLoading();
  const [error, setError] = useState(null);

  // Handle form input changes, ensuring controlled input
  const handleChange = (e) => {
    setUserData({
      ...userData,
      [e.target.name]: e.target.value,
    });
  };

  // Submit form data
  const handleEdit = (event) => {
    event.preventDefault();
    axios
      .patch(
        `${process.env.REACT_APP_API_BASE_URL}/auth/update/${id}/`,
        userData
      )
      .then((response) => {
        // console.log(response.data);
        navigate("/user_dashboard");
      })
      .catch((error) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          alert(error.response.data.message); // Show the backend error message as an alert
        } else {
          console.error(error);
        }
      });
  };

  // Fetch user data from the API and prefill the form
  useEffect(() => {
    setLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/auth/users/${id}/`)
      .then((response) => {
        const user = response.data.data;
        // Prefill form with fetched data, ensuring fields are not null
        setUserData({
          first_name: user.first_name || "",
          last_name: user.last_name || "",
          email: user.email || "",
          phone_number: user.phone_number || "",
          organization: user.organization || "",
          designation: user.designation || "",
          role: user.role || "",
          user_type: user.user_type || "",
        });
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setError(error);
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return (
      <div
        className="container d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div>
          <div
            className="spinner-border text-dark"
            role="status"
            style={{ width: "3rem", height: "3rem" }}
          >
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
        <h3 className="text-center text-dark">&nbsp;Data is Fetching.... </h3>
      </div>
    );
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <>
      <NavbarForOnboardingForm />
      <div className="container py-5">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-10 col-md-8 col-lg-6 col-xl-5 log">
            <div className="card border border-dark text-dark">
              <div
                className="card-header border-dark text-white"
                style={{ background: "#008cba" }}
              >
                <h4 className="text-center font_header">Update User Form</h4>
              </div>
              <div className="card-body">
                <form onSubmit={handleEdit}>
                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <div data-mdb-input-init className="form-outline">
                          <label className="form-label" htmlFor="first_name">
                            First Name
                          </label>
                          <input
                            type="text"
                            id="first_name"
                            name="first_name"
                            className="form-control border-dark text-dark"
                            value={userData.first_name}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div data-mdb-input-init className="form-outline">
                          <label className="form-label" htmlFor="last_name">
                            Last Name
                          </label>
                          <input
                            type="text"
                            id="last_name"
                            name="last_name"
                            className="form-control border-dark text-dark"
                            value={userData.last_name}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <label htmlFor="email" className="form-label">
                          Email address
                        </label>
                        <input
                          type="email"
                          className="form-control border-dark text-dark"
                          id="email"
                          name="email"
                          value={userData.email}
                          onChange={handleChange}
                          readOnly
                        />
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="phone_number" className="form-label">
                          Phone Number
                        </label>
                        <input
                          type="tel"
                          className="form-control border-dark text-dark"
                          id="phone_number"
                          name="phone_number"
                          pattern="(\+91)?[6-9][0-9]{9}"
                          value={userData.phone_number}
                          onChange={handleChange}
                          readOnly
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mb-2">
                    <div className="row">
                      <div className="col-md-6">
                        <label htmlFor="organization" className="form-label">
                          Organization
                        </label>
                        <input
                          type="text"
                          className="form-control border-dark text-dark"
                          id="organization"
                          name="organization"
                          value={userData.organization}
                          onChange={handleChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <label htmlFor="designation" className="form-label">
                          Designation
                        </label>
                        <input
                          type="text"
                          className="form-control border-dark text-dark"
                          id="designation"
                          name="designation"
                          value={userData.designation}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mb-2">
                    <label htmlFor="role" className="form-label">
                      Role
                    </label>
                    <input
                      type="text"
                      className="form-control border-dark text-dark"
                      id="role"
                      name="role"
                      aria-describedby="emailHelp"
                      value={userData.role}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">User Type</label>
                    <div className="row">
                      {/* First Row */}
                      <div className="col-md-6">
                        <div className="form-check">
                          <input
                            type="radio"
                            id="admin"
                            name="user_type"
                            className="form-check-input border-dark"
                            value="admin"
                            onChange={handleChange}
                            checked={userData.user_type === "admin"}
                          />
                          <label className="form-check-label" htmlFor="admin">
                            Admin
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-check">
                          <input
                            type="radio"
                            id="hr"
                            name="user_type"
                            className="form-check-input border-dark"
                            value="hr"
                            onChange={handleChange}
                            checked={userData.user_type === "hr"}
                          />
                          <label className="form-check-label" htmlFor="hr">
                            HR
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      {/* Second Row */}
                      <div className="col-md-6">
                        <div className="form-check">
                          <input
                            type="radio"
                            id="manager"
                            name="user_type"
                            className="form-check-input border-dark"
                            value="manager"
                            onChange={handleChange}
                            checked={userData.user_type === "manager"}
                          />
                          <label className="form-check-label" htmlFor="manager">
                            Manager
                          </label>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-check">
                          <input
                            type="radio"
                            id="recruiter"
                            name="user_type"
                            className="form-check-input border-dark"
                            value="recruiter"
                            onChange={handleChange}
                            checked={userData.user_type === "recruiter"}
                          />
                          <label
                            className="form-check-label"
                            htmlFor="recruiter"
                          >
                            Recruiter
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="text-center py-2">
                    <button type="submit" className="btn btn-outline-info me-2">
                      Submit
                    </button>
                    <button
                      className="btn btn-outline-danger"
                      type="button"
                      onClick={() => navigate("/user_dashboard")}
                    >
                      Close
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditUser;
